<template>
  <div class="main-content queryJob">
    <search-item
      :key="identify"
      :ref="identify"
      :is-simple-query.sync="isSimpleQuery"
      :auto-init="false"
      :show-more-scheme="false"
      :show-simple="false"
      :expand-adv="true"
      reset
      :custom-search-items="customSearchItems"
      :search-item-code="$t('CargoMsg.Cargo_FinancialAudit')"
      :custom-sim-query-placeholder="$t('Clearing.QuickSearchBusinessNumber')"
      :config-module="configModule"
      :col-settings="colSettings"
      @query="queryHandler"
      @advToggle="scrollCallback"
    >
      <template slot="operations">
        <slot name="operations" />
      </template>
      <template slot="searchAreaHeader">
        <slot name="searchAreaHeader" />
      </template>
    </search-item>
    <div class="section grid-wrapper">
      <cargo-ag-grid
        :config-module="gridConfigModule"
        :grid-params.sync="gridParams"
        :grid-options="gridOptions"
        :check-main-record="false"
        :deselect-main-record="false"
        :column-defs="columnDefs"
        :row-data="rowData"
        :min-height="hasVoucher===0?'350px':'200px'"
        style="width: 100%;"
        @girdReady="onGridReady"
      />
    </div>
    <div id="footer-wrapper-tab-job" class="pagination-wrapper">
      <div :class="[shouldFixed?'fixedBottom':'']" class="total-wrapper">
        <span v-show="showSelectionCount">
          {{ selectionCountLabel }}
        </span>
        <charge-currency-total-group
          v-if="reCalc"
          :key="1"
          :amount-to-currency="localCurrency"
          mode="simple"
          :data-field="fieldIncome"
          type="both"
          :data-provider="financeManageHP.totalGroupIncome.dataProvider"
          currency-field="currency"
          :amount-to-currency-label="amountToCurrencyLabelIncome"
        />
        <charge-currency-total-group
          v-if="reCalc"
          :key="2"
          :amount-to-currency="localCurrency"
          mode="simple"
          :data-field="fieldCost"
          type="both"
          :data-provider="financeManageHP.totalGroupCost.dataProvider"
          currency-field="currency"
          :amount-to-currency-label="amountToCurrencyLabelCost"
        />
        <charge-currency-total-group
          v-if="reCalc && showTotalGroup"
          :key="3"
          :amount-to-currency="localCurrency"
          mode="simple"
          data-field="realProfit"
          type="both"
          :data-provider="financeManageHP.totalGroup.dataProvider"
          currency-field="currency"
          :amount-to-currency-label="$t('CargoMsg.Cargo_Profit')"
        />
        <charge-count-group
          v-if="reCalc && showTotalGroup && !['VoucherList'].includes(viewSource)"
          :data-provider="financeManageHP.chargeCountGroup.dataProvider"
          :basic-currency="localCurrency"
          :new-by-job="3"
          :show-rmb="true"
          :always-show="false"
        />
      </div>
      <cargo-pagination
        :config-module="gridConfigModule"
        :total="searchConditions.total"
        :page-count="searchConditions.pageCount"
        :page.sync="searchConditions.pageNum"
        :limit.sync="searchConditions.pageSize"
        @pagination="queryPageHandler"
      />
    </div>
  </div>
</template>

<script>
import lodash from 'lodash'
import { DocumentManage, stopBubble, Once } from '@/utils/commonUtil'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import OperatorConstants from '@/class/cargo/model/parameters/OperatorConstants'
import * as ChargeConstants from '@/class/cargo/model/parameters/ChargeConstants'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as LoadDefaultQueryParam from '@/utils/LoadDefaultQueryParam'
import * as AdvancedSearchConsts from '@/class/cargo/model/utils/AdvancedSearchConsts'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import moment from 'moment'
import ChargeCountGroup from '@/components/Cargo/Act/chargeSummary/ChargeCountGroup.vue'
import ChargeCurrencyTotalGroup from '@/components/Cargo/Act/chargeSummary/ChargeCurrencyTotalGroup.vue'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import { getGridSelected } from '@/utils/agGrid'
import FinanceManageHP from '@/views/cargo/v0/Clearing/components/financeManage/financeManageHp'
import * as SpecialFieldConstants from '@/utils/SpecialFieldConstants'
import StrUtils from '@/utils/StrUtils'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { OPERATOR_EQUAL } from '@/class/cargo/model/utils/AdvancedSearchConsts'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'

export default {
  name: 'QueryJob',
  components: { ChargeCurrencyTotalGroup, ChargeCountGroup, searchItem },
  props: {
    identify: { type: String, required: true, default: 'queryJob' }, // ID
    viewSource: { type: String, required: true, default: 'VoucherList' }, // 引用页面
    jobStates: { type: Array, default: () => [] }, // 业务状态
    isAr: { type: Number, default: -1 }, //  是否应收
    hasBillPayment: { type: Number, default: -1 }, // 是否有付款申请
    showTotalProfit: { type: Boolean, default: false }, // 显示总利润 (全量数据)
    showCostColumn: { type: Boolean, default: true }, // 是否显示总成本
    showRevenueColumn: { type: Boolean, default: true }, // 是否显示总收入
    showVoucherDate: { type: Boolean, default: false }, // 显示生成凭证日期
    hasCheckRole: { type: Boolean, default: false }, // 是否根据权限查询数据
    isSimpleQuery: { type: Boolean, default: false },
    isExt: { type: Boolean, default: false },
    accountSetKey: { type: String, default: '' }, // 账套uuid
    hasVoucher: { type: Number, default: -1 }, // 是否已经生成过凭证:1=是,0=否
    voucherPage: { type: Number, default: 0 },
    showTotalGroup: { type: Boolean, default: true }, // 是否显示利润
    configModule: { type: String, default: '501' }, // 高级查询条件
    gridConfigModule: { type: String, default: '180301' }, // 列表设置
    colSettings: { type: Object },
    accountSetBranchId: { type: Number, default: 0 }, // 账套branchId,
    filterCharge: { type: Boolean, default: false } // 是否要筛选费用
  },
  data() {
    return {
      localCurrency: 'RMB',
      routeJobNo: '',
      selectedJob: {},
      customConditions: [],
      allJobByRole: false, // 查看所有业务
      searchExportExcel: false, // 全部数据，用于导出
      departmentJobByRole: false, // 查看同组业务
      userJobByRole: false, // 查看自己业务
      departmentTeamUser: [], // 同部门的人
      customSearchItems: [], // 自定义高级查询项
      financeManageHP: new FinanceManageHP(this),
      loading: false,
      showControlledProfit: false,
      documentManage: new DocumentManage(),
      detailViewSource: '', // detailView详情页的来源
      searchConditions: {
        total: 0,
        pageCount: 0,
        pageNum: 1,
        pageSize: 50,
        simpleTriggerMode: false, // 是否为简单查询触发模式
        snapshotConditions: [], // 高级查询条件（点击查询时的快照状态）
        requires: []
      },
      gridOptions: {
        onSelectionChanged(event) {
          console.log('onSelectionChanged', event)
        },
        onRowDoubleClicked: this.showDetailView4Manage
      },
      gridParams: {},
      gridApi: {},
      columnDefs: [{ headerName: this.$t('queryJob.businessNumber'), field: 'jobNo', width: 180 }],
      rowData: [],
      simpleTriggerMode: false, // 记录上一次的查询条件，导出全部使用
      beforeConditions: null, // 记录上一次的查询条件，导出全部使用
      shouldFixed: false,
      showSelectionCount: true,
      selectionCountLabel: '',
      once: new Once(this),
      reCalc: true // 折合重算
    }
  },
  computed: {
    fieldIncome() {
      return this.voucherPage === 2 ? 'receivableNoVoucherStatistics' : 'income'
    },
    fieldCost() {
      return this.voucherPage === 2 ? 'payableNoVoucherStatistics' : 'cost'
    },
    amountToCurrencyLabelIncome() {
      return this.voucherPage === 2 ? this.$t('queryJob.NoVoucherGeneratedReceivable') : this.$t('CargoMsg.Cargo_Receivable')
    },
    amountToCurrencyLabelCost() {
      return this.voucherPage === 2 ? this.$t('queryJob.NoVoucherGeneratedPayable') : this.$t('CargoMsg.Cargo_Dues')
    }
  },
  watch: {
    rowData(newVal) {
      if ((!newVal || newVal.length === 0) && this.routeJobNo) {
        this.$message.error(this.$t('Clearing.YouPermissionToViewData'))
      }
    }
  },
  created() {
    this.financeManageHP.created()
    this.financeManageHP.initializeHandler()
    this.setLocalCurrency()
  },
  beforeMount() {
    this.financeManageHP.beforeMount()
  },
  mounted() {
    this.getSearchField()
    this.routeJobDetails()
    this.scrollCallback()
    // document.querySelector('.app-main-content').addEventListener('scroll', this  .scrollCallback)
  },
  activated() {
    this.routeJobDetails()
    this.reSetChargeCurrencyTotalGroup()
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  destroyed() {
    // document.querySelector('.app-main-content').removeEventListener('scroll', this.scrollCallback, false)
  },
  methods: {
    // 财务审核页筛选值变化事件
    filterChange() {
      this.$nextTick(() => {
        this.financeManageHP.refreshSelectedCount()
      })
    },
    onGridReady(params) {

    },
    routeJobDetails() {
      const { query } = this.$route
      if (query.jobNo && !this.showDetail) {
        this.routeJobNo = query.jobNo
        this.queryHandler({ simpleTriggerMode: true, conditions: this.routeJobNo })
      }
    },
    getSearchField() {
      // 业务日期
      let searchField = new AdvancedSearchField()
      searchField.itemType = 'date'
      searchField.itemCondition = []
      searchField.defaultConditionVal = 'RANGE'
      searchField.fieldType = 'FIELD_DATE_RANGE'
      searchField.itemName = 'job.business_date'
      searchField.itemLabel = 'queryJob.businessDate'
      const startDate = moment().subtract(1, 'months').format('YYYY-MM-DD') // 当前时间的前一个月时间
      searchField.itemValue = [startDate]
      searchField.subType = 'range'
      searchField.defaultSelected = 1
      searchField.selected = 0
      searchField.lock = false
      searchField.defaultValue = []
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      this.customSearchItems.push(searchField.formatObj2Json())

      // 是否调整费用
      searchField = new AdvancedSearchField()
      searchField.itemType = 'select'
      searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
      searchField.itemCondition = [OPERATOR_EQUAL]
      searchField.itemName = 'charge.ADJUSTMENT'
      searchField.itemLabel = 'CargoMsg.Cargo_AdjustExpenseOrNot'
      searchField.dropdownDataRef = 'ChargeConstants.CHARGE_ADJUSTMENT_STATES'
      searchField.dataCacheKey = 'local_cache_ChargeConstants$CHARGE_ADJUSTMENT_STATES'
      searchField.action = AdvancedSearchField.ADD_ACTION
      this.customSearchItems.push(searchField.formatObj2Json())
    },
    // 分页触发查询
    queryPageHandler() {
      this.searchExportExcel = false
      this.financeManageHP.doSearchWithProfitAndList()
    },
    // 查询触发
    queryHandler({ simpleTriggerMode, conditions }) {
      // 测试使用 console.log('grid==>', this.gridOptions)
      this.searchExportExcel = false
      this.simpleTriggerMode = simpleTriggerMode// 简单查询导出全部
      this.beforeConditions = conditions// 简单查询导出全部
      this.search2({ simpleTriggerMode, conditions })
    },
    search2({ simpleTriggerMode, conditions }) {
      this.searchConditions.pageNum = 1
      const finallyConditions = []
      this.searchConditions.simpleTriggerMode = simpleTriggerMode
      if (this.searchConditions.simpleTriggerMode) {
        if (!conditions) {
          this.$message.warning(this.$t('FinanceManage.finance_inputBusinessNumber'))
          return
        }

        if (this.routeJobNo) { // 跳转查询直接根据jobNo精确查询
          const option = new AdvancedSearchOption(null, 'job.job_no', conditions.trim(), OperatorConstants.OPERATOR_EQUAL.code)
          finallyConditions.push(option.formatObj2Json())
        } else {
          // 简单查询，则 combiConditions为string
          const option = new AdvancedSearchOption(null, 'job.job_no', conditions.trim(), OperatorConstants.OPERATOR_LIKE.code)
          finallyConditions.push(option.formatObj2Json())
        }
      } else {
        // 高级查询条件组装
        const advConditions = conditions ? lodash.cloneDeep(conditions) : []
        if (AdvancedSearchOption.hasField('charge.offset_state', advConditions)) {
          const option = AdvancedSearchOption.getOption('charge.offset_state', advConditions)
          if (option.value === false) {
            option.value = ChargeConstants.OFFSET_STATE_NORMAL.code
          } else {
            option.operator = OperatorConstants.OPERATOR_IN.code
            option.value = `${ChargeConstants.OFFSET_STATE_HEDGE.code}, ${ChargeConstants.OFFSET_STATE_BE_HEDGE.code}`
          }
          // 更新某一項
          AdvancedSearchOption.updateOption(option, advConditions)
        }
        if (AdvancedSearchOption.hasField('job.job_state', advConditions)) {
          const option = AdvancedSearchOption.getOption('job.job_state', advConditions)
          if (option.operator === OperatorConstants.OPERATOR_NOT_IN.code) {
            const optionList = option.value
            optionList.push(-1)
            optionList.push(12)
            option.value = optionList
            // 更新某一項
            AdvancedSearchOption.updateOption(option, advConditions)
          }
        }
        const lcOption = AdvancedSearchOption.getOption('job.localSevice', advConditions)
        if (lcOption != null) {
          const codes = lcOption.value
          const services = []
          for (const code of codes) {
            const service = CommonState.getStateByCode(SeaExportConstants.STUFFY_TYPES, code)
            if (service != null) services.push(service)
          }
          const stuffingTypes = this.convertStuffyTypeToQuery(services)
          for (const stuffing in stuffingTypes) {
            advConditions.push(new AdvancedSearchOption(null, stuffingTypes[stuffing], true).formatObj2Json())
          }
        }
        if (AdvancedSearchOption.hasField('job.localSevice', advConditions)) {
          AdvancedSearchOption.removeOption('job.localSevice', advConditions)
        }
        finallyConditions.push(...advConditions)
      }
      this.toSupplementConditionsBeforeQuery(finallyConditions)
      // 条件保存
      this.searchConditions.snapshotConditions = finallyConditions
      // 查询列表+利润
      this.financeManageHP.doSearchWithProfitAndList()
    },
    // 查询请求前补充条件
    toSupplementConditionsBeforeQuery(finallyConditions) {
      if (this.customConditions && this.customConditions.length > 0) { finallyConditions.push(...this.customConditions) }

      if (this.jobStates && this.jobStates.length > 0 && !LoadDefaultQueryParam.isSelectOption(finallyConditions, 'job.job_state')) {
        const option = new AdvancedSearchOption(null, 'job.job_state', LoadDefaultQueryParam.convertCommonStateToInt(this.jobStates), AdvancedSearchConsts.OPERATOR_IN.code)
        finallyConditions.push(option.formatObj2Json())
      } else if (!AdvancedSearchOption.hasField('job.job_state', finallyConditions)) {
        const option = new AdvancedSearchOption(null, 'job.job_state', LoadDefaultQueryParam.convertCommonStateToInt(SystemConstants.JOB_STATES), AdvancedSearchConsts.OPERATOR_IN.code)
        finallyConditions.push(option.formatObj2Json())
      }

      if (this.hasBillPayment !== -1) {
        finallyConditions.push(new AdvancedSearchOption(null, 'charge.bill_payment_uuid', null, this.hasBillPayment === 0 ? AdvancedSearchConsts.OPERATOR_IS_NULL.code : AdvancedSearchConsts.OPERATOR_IS_NOT_NULL.code).formatObj2Json())
      }
      this.$logger.log('finallyConditions4=====', finallyConditions)
      if (this.isAr !== -1) { finallyConditions.push(new AdvancedSearchOption(null, 'charge.receivable', Number(this.isAr) === 1).formatObj2Json()) }
      // 是否生成凭证
      if (this.hasVoucher !== -1 && !StrUtils.isEmpty(this.accountSetKey)) {
        finallyConditions.push(new AdvancedSearchOption(null, SpecialFieldConstants.JOB_VOUCHERED_NATIVE, { 'accountSetKey': this.accountSetKey }, this.hasVoucher === 1 ? AdvancedSearchConsts.OPERATOR_IN.code : AdvancedSearchConsts.OPERATOR_NOT_IN.code).formatObj2Json())
      }
      // 是否显示关联业务  后端此查询条件做特殊处理了，如果不传默认为true，故前端无需处理
      // if (AdvancedSearchOption.hasField(SpecialFieldConstants.LOAD_RELATION_JOBS, conditions)) {
      //   var option:AdvancedSearchOption = AdvancedSearchOption.getOption(SpecialFieldConstants.LOAD_RELATION_JOBS, conditions);
      //   super.loadRelationJobs = option.value;
      // } else {
      //   super.loadRelationJobs = true;
      // }
      const requires = []
      if (this.showRevenueColumn || this.showCostColumn) { requires.push('revenue') }
      if (this.showVoucherDate) { requires.push('voucherDate') }
      if (this.showTotalProfit) { requires.push('showTotalProfit') }
      if (this.voucherPage > 0) {
        requires.push('voucherPage')
        if (this.filterCharge) {
          requires.push('filterCharge')
        }
      }
      this.searchConditions.requires = requires
    },
    // 业务编号旁的搜索按钮事件
    showTemplateDialog(e) {
      // TemplateSelectorWin.getInstance().showThisWin(data as AbstractEntity, "JOB_DETAIL_OP", {"JOB_UUID":data.key}, FlexGlobals.topLevelApplication as DisplayObject);
      stopBubble(e)
      // if (!this.selectedJob) return
      // this.templateSelectorDialog.cxt = this.selectedJob
      // this.templateSelectorDialog.category = 'JOB_DETAIL_OP'
      // this.templateSelectorDialog.data = { 'JOB_UUID': this.selectedJob.uuid }
      // this.templateSelectorDialog.visible = true
      this.$emit('toSearchTemplate', this.selectedJob.uuid)
    },
    async showDetailView4Manage({ data } = {}, needChecked = false) {
      // this.financeManageHP.showDetailView(needChecked, { ...data }, this.gridOptions, this.rowData)
      this.$emit('showDetailView', needChecked, { ...data }, this.gridOptions, this.rowData)
    },
    scrollCallback() {
      this.$nextTick(() => {
        const container = document.querySelector('.parent-wrapper')
        const footer = document.getElementById('footer-wrapper-tab-job')
        const containerHeight = container.clientHeight - footer.offsetHeight
        const offset = footer.offsetTop - container.scrollTop
        console.log('containerHeight', containerHeight)
        console.log('offset', offset)
        if (offset > containerHeight + 50) {
          this.shouldFixed = true
        } else {
          this.shouldFixed = false
        }
      })
    },
    // 获取勾选的项目
    getSelections() {
      return getGridSelected(this.gridOptions)
    },
    // 是否红冲
    isRedPunch() {
      return false
    },
    reSetChargeCurrencyTotalGroup() {
      // 折合重算
      setTimeout(() => { this.reCalc = false }, 100)
      setTimeout(() => { this.reCalc = true }, 100)
    },
    setLocalCurrency() {
      this.localCurrency = RateUtil.localCurrencyByOffice()
      if (this.localCurrency !== 'RMB') {
        setTimeout(() => { this.reCalc = false }, 100)
        setTimeout(() => { this.reCalc = true }, 100)
      }
    },
    // 本地服务条件处理
    convertStuffyTypeToQuery(items) {
      const result = []
      for (const stuffyType of items) {
        if (stuffyType.code === 'IS') {
          result.push('job.WAREHOUSING')
        } else if (stuffyType.code === 'DD') {
          result.push('job.LAND_TRANSPORTATION')
        } else if (stuffyType.code === 'SD') {
          result.push('job.SELF_DELIVER')
        } else if (stuffyType.code === 'CT') {
          result.push('seaJob.CUSTOMS')
        } else if (stuffyType.code === 'HT') {
          result.push('seaJob.HEATING')
        } else if (stuffyType.code === 'CIT') {
          result.push('seaJob.COMERCIAL_INSPECTATION')
        } else if (stuffyType.code === 'AMS') {
          result.push('seaJob.AMS')
        } else if (stuffyType.code === 'ISBOOKING') {
          result.push('job.BOOKING')
        } else if (stuffyType.code === 'BACK_UP_WAREHOUSE') {
          result.push('job.BACK_UP_WAREHOUSE')
        }
      }
      return result
    }
  }
}
</script>

<style lang="scss">
#footer-wrapper {
  align-items: center;
  .fixedBottom {
    position: fixed;
    bottom: 0;
    right: 15px;
    background: #fff;
  }
}
</style>
